import { type RulesLogic } from "json-logic-js";
import { cloneDeep } from "lodash";
import {
  type Config as ConfigType,
  type ImmutableTree,
  Utils as QbUtils,
} from "react-awesome-query-builder";

import BasicConfig from "@components/raqb-bootstrap/config";

export const ADVANCED_SEARCH_EDITOR_CONFIG: Readonly<ConfigType> = {
  ...BasicConfig,
  settings: {
    ...BasicConfig.settings,
    showNot: false,
    valueSourcesInfo: {
      value: {
        label: "Value",
      },
    },
  },
  fields: {
    campaignName: { type: "text", label: "Campaign Name" },
    adsetName: { type: "text", label: "Adset Name" },
    adName: { type: "text", label: "Ad Name" },
    adKey: { type: "text", label: "Ad Key" },
    date: { type: "text", label: "Date" },
  },
} as any;

const DEFAULT_RULE = {
  and: [
    {
      "==": [
        {
          var: "campaignName",
        },
        "",
      ],
    },
  ],
};

export function getAdvancedSearchEditorConfig(breakdowns: string[]): any {
  return cloneDeep({
    ...ADVANCED_SEARCH_EDITOR_CONFIG,
    fields: {
      ...ADVANCED_SEARCH_EDITOR_CONFIG.fields,
      ...breakdowns.reduce((acc, e) => {
        acc[`breakdown:${e}`] = { type: "text", label: e };
        return acc;
      }, {} as Record<string, { type: string; label: string }>),
    },
  });
}

export function getDefaultRule(): any {
  return cloneDeep(DEFAULT_RULE);
}

export function searchTreeToJsonLogic(
  tree: ImmutableTree,
  breakdowns: string[],
): RulesLogic {
  return QbUtils.jsonLogicFormat(
    tree,
    getAdvancedSearchEditorConfig(breakdowns),
  ).logic! as RulesLogic;
}

export function jsonLogicToSearchTree(
  jsonLogic: RulesLogic,
  breakdowns: string[],
): ImmutableTree {
  return QbUtils.loadFromJsonLogic(
    jsonLogic,
    getAdvancedSearchEditorConfig(breakdowns),
  );
}
